export default {"src":"/_next/static/media/cheveron-bottom-gray.5790bd11.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};